<template>
  <div>
    <the-sidebar />
    <Notifications />
    <v-main>
      <v-toolbar flat class="mb-2">
        <v-toolbar-title>
          <h1 class="text-h6 font-weight-bold">{{ $t(pageTitle) }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import TheSidebar from '@/components/sidebar/the-sidebar.vue';
import Notifications from '@/components/notifications/notifications.vue';

export default Vue.extend({
  components: {
    TheSidebar,
    Notifications
  },

  computed: {
    pageTitle(): string {
      return this.$route.meta.pageTitle;
    }
  }
});
</script>
